import React from 'react';
import { M } from '@dashboard-experience/mastodon';
import { Link } from 'react-router-dom';

const HomePageLink: React.FC<{ children: React.ReactNode; href: string }> = ({
  children,
  href,
}) => {
  const className = 'report-nav--item report-nav--item__home';
  const dataTestId = 'back-to-all-reports';

  if (href.startsWith('http')) {
    return (
      <a href={href} className={className} data-testid={dataTestId}>
        {children}
      </a>
    );
  }

  return (
    <Link to={href} className={className} data-testid={dataTestId}>
      {children}
    </Link>
  );
};

export const Navigation: React.FC<{
  homeLink: { href: string; text: string };
  className?: string;
}> = ({ homeLink, className = '' }) => {
  return (
    <nav className={`report-nav${className ? ` ${className}` : ''}`}>
      <ul className='nav-list'>
        <li className='nav-list--item'>
          <HomePageLink href={homeLink.href}>
            <M.Icon icon='ChevronLeft' />
            {homeLink.text}
          </HomePageLink>
        </li>
      </ul>
    </nav>
  );
};
